import SiteNavbar from '../components/SiteNavbar';

export default function WaitlistedPage() {
  return (
    <div className="flex min-h-screen flex-col bg-white dark:bg-gray-900">
      <SiteNavbar />

      <main className="flex flex-1 flex-col items-center justify-center px-4 py-16 text-center">
        <h1 className="mb-4 text-3xl font-bold text-primary">You’re on the list! 🎉</h1>
        <p className="max-w-md text-gray-700 dark:text-gray-300">
          Thanks for registering. We’ll email you as soon as a spot becomes available.
        </p>
        <a href="/" className="mt-6 inline-block text-sm font-medium text-primary underline">
          Back to home
        </a>
      </main>
    </div>
  );
}
